import React from 'react';
import { motion } from 'framer-motion';
interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  label: string;
}
export function StepIndicator({
  currentStep,
  totalSteps,
  label
}: StepIndicatorProps) {
  // We don't show step 1 (Start) or steps 10+ (Summary and Post-PTP flow) in the progress bar
  const displayStep = currentStep - 1;
  const displayTotal = 8; // Steps 2 through 9
  if (currentStep === 1 || currentStep >= 10) return null;
  return <div className="w-full mb-6" data-id="element-1096">
      <div className="flex gap-1 mb-3" data-id="element-1097">
        {Array.from({
        length: displayTotal
      }).map((_, i) => {
        const stepNumber = i + 1;
        let bgColor = 'bg-slate-800';
        if (stepNumber === displayStep) bgColor = 'bg-orange-500';else if (stepNumber < displayStep) bgColor = 'bg-green-500';
        return <motion.div key={i} className={`h-1.5 flex-1 rounded-full ${bgColor}`} layout transition={{
          duration: 0.3
        }} data-id="element-1098" />;
      })}
      </div>
      <div className="flex justify-between items-center text-xs font-medium" data-id="element-1099">
        <span className="text-orange-500 uppercase tracking-wider" data-id="element-1100">
          Step {displayStep} of {displayTotal}
        </span>
        <span className="text-slate-400" data-id="element-1101">{label}</span>
      </div>
    </div>;
}